var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout" }, [
    _c("div", { staticClass: "md-layout-item" }, [
      _c("div", { staticClass: "custom-toolbar" }, [
        _c("div", { staticClass: "custom-toolbar-start" }, [
          _c("div", [
            _c("div", { staticClass: "md-layout" }, [
              _c(
                "div",
                { staticClass: "md-layout-item md-size-30" },
                [
                  _c(
                    "md-datepicker",
                    {
                      staticClass: "md-layout-item",
                      attrs: { "md-model-type": String, "md-immediately": "" },
                      model: {
                        value: _vm.searchDateFrom,
                        callback: function ($$v) {
                          _vm.searchDateFrom = $$v
                        },
                        expression: "searchDateFrom",
                      },
                    },
                    [_c("label", [_vm._v("From Date")])]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item md-size-30" },
                [
                  _c(
                    "md-field",
                    [
                      _c("label", [_vm._v("Detection Results Filter")]),
                      _c(
                        "md-select",
                        {
                          attrs: { "md-no-validate": "" },
                          model: {
                            value: _vm.selectedInvalidImageFilterType,
                            callback: function ($$v) {
                              _vm.selectedInvalidImageFilterType = $$v
                            },
                            expression: "selectedInvalidImageFilterType",
                          },
                        },
                        [
                          _c("md-option", { attrs: { value: 0 } }, [
                            _vm._v("Failed Detection"),
                          ]),
                          _c("md-option", { attrs: { value: 1 } }, [
                            _vm._v("House Number Mismatch"),
                          ]),
                          _c("md-option", { attrs: { value: 2 } }, [
                            _vm._v("No Filter (show all)"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "md-layout-item md-size-30" },
                [
                  _c(
                    "md-field",
                    [
                      _c("label", [_vm._v("Team Member")]),
                      _c(
                        "md-select",
                        {
                          attrs: { "md-no-validate": "" },
                          model: {
                            value: _vm.selectedTeamMemberId,
                            callback: function ($$v) {
                              _vm.selectedTeamMemberId = $$v
                            },
                            expression: "selectedTeamMemberId",
                          },
                        },
                        [
                          _c("md-option", { attrs: { value: 0 } }, [
                            _vm._v("All"),
                          ]),
                          _vm._l(_vm.teamMembers, function (member) {
                            return _c(
                              "md-option",
                              {
                                key: member.userId,
                                attrs: { value: member.userId },
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(member.firstName) +
                                    " " +
                                    _vm._s(member.lastName) +
                                    "\n                                    "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "custom-toolbar-end" }, [
          _c(
            "div",
            [
              _c(
                "md-button",
                {
                  staticClass:
                    "md-primary md-just-icon md-round pull-right header-button",
                  attrs: { title: "Refresh List" },
                  on: { click: _vm.onStartup },
                },
                [_c("md-icon", [_vm._v("refresh")])],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "md-layout-item md-size-100" },
      [
        _c(
          "md-card",
          [
            _c(
              "md-card-header",
              { staticClass: "md-card-header-icon md-card-header-green" },
              [_c("div", { staticClass: "md-title" }, [_vm._v("Vision List")])]
            ),
            _c(
              "md-card-content",
              [
                _c(
                  "md-table",
                  [
                    _c(
                      "md-table-row",
                      [
                        _c("md-table-head", [_vm._v("Date")]),
                        _c("md-table-head", [_vm._v("Driver")]),
                        _c("md-table-head", [_vm._v("Parcel?")]),
                        _c("md-table-head", [_vm._v("House Num?")]),
                        _c("md-table-head", [_vm._v("Image")]),
                      ],
                      1
                    ),
                    _vm._l(_vm.imageVisionList, function (imageVision) {
                      return _c(
                        "md-table-row",
                        { key: imageVision.fileName },
                        [
                          _c(
                            "md-table-cell",
                            [
                              imageVision.stopId
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Stop Details",
                                          params: {
                                            stopId: imageVision.stopId,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              imageVision.noteDate,
                                              _vm.DATE_TYPES.standardDate
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : imageVision.shipmentId
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Shipment Details",
                                          params: {
                                            shipmentId: imageVision.shipmentId,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              imageVision.noteDate,
                                              _vm.DATE_TYPES.standardDate
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFormat")(
                                          imageVision.noteDate,
                                          _vm.DATE_TYPES.standardDate
                                        )
                                      )
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _c("md-table-cell", [
                            _vm._v(_vm._s(imageVision.driverName)),
                          ]),
                          _c(
                            "md-table-cell",
                            [
                              imageVision.isParcelDetected
                                ? _c("md-icon", { staticClass: "md-success" }, [
                                    _vm._v("check"),
                                  ])
                                : _c("md-icon", { staticClass: "md-danger" }, [
                                    _vm._v("close"),
                                  ]),
                            ],
                            1
                          ),
                          _c(
                            "md-table-cell",
                            [
                              imageVision.isNumberDetected
                                ? _c("md-icon", { staticClass: "md-success" }, [
                                    _vm._v("check"),
                                  ])
                                : _c("md-icon", { staticClass: "md-danger" }, [
                                    _vm._v("close"),
                                  ]),
                            ],
                            1
                          ),
                          _c("md-table-cell", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: imageVision.fileName,
                                  download: "",
                                  target: "_blank",
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "thumbnail-icon",
                                  attrs: {
                                    src: imageVision.thumbFileName,
                                    alt: "",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }